// Whether the working copy may go for review right now, and if not, why.
//
// "Submit for review" does not send the editor's bytes — it asks the server to move the copy it
// ALREADY HOLDS into review. So while the editor holds edits the server has not accepted (a save
// still in flight, or one refused for size), submitting would send a stale copy and silently drop
// the latest changes. Someone did exactly that: pasted images past the 50 MB limit, saw the
// warning, submitted anyway, and the reviewer never saw the images.
import type { EditorSaveState } from './components/docx/DocxEditor';
import { WORKING_COPY_MAX_BYTES } from './limits';

const LIMIT_MB = Math.round(WORKING_COPY_MAX_BYTES / (1024 * 1024));

/** `null` when submitting is safe; otherwise the sentence to show on the disabled button. */
export function submitBlockReason(state: EditorSaveState): string | null {
  switch (state) {
    case 'saving':
    case 'unsaved':
      return 'Still saving your latest edits — wait for "All changes saved".';
    case 'too_large':
      return `The document is over the ${LIMIT_MB} MB limit, so your latest edits are not saved. Submitting now would send only the last saved copy. Remove or shrink large images first.`;
    default:
      return null;
  }
}
